/* Full size viewer for article galleries.

   The gallery images are cropped to a shared 3:2 tile so the rows line up.
   That is right for the grid and wrong for looking at a photograph, so any
   image opens uncropped. Keyboard: arrows move, Escape closes, and focus
   returns to the image you opened from. */
(function () {
  'use strict';

  var box, imgEl, countEl, items = [], at = 0, opener = null;

  function build() {
    box = document.createElement('div');
    box.className = 'corp-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="corp-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="corp-lightbox__nav corp-lightbox__nav--prev" aria-label="Previous image">&#8249;</button>' +
      '<img alt="">' +
      '<button type="button" class="corp-lightbox__nav corp-lightbox__nav--next" aria-label="Next image">&#8250;</button>' +
      '<span class="corp-lightbox__count"></span>';
    document.body.appendChild(box);
    imgEl = box.querySelector('img');
    countEl = box.querySelector('.corp-lightbox__count');

    box.querySelector('.corp-lightbox__close').addEventListener('click', close);
    box.querySelector('.corp-lightbox__nav--prev').addEventListener('click', function (e) {
      e.stopPropagation(); step(-1);
    });
    box.querySelector('.corp-lightbox__nav--next').addEventListener('click', function (e) {
      e.stopPropagation(); step(1);
    });
    /* clicking the backdrop, but not the photograph itself, closes it */
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
  }

  function show(i) {
    at = (i + items.length) % items.length;
    var el = items[at];
    imgEl.src = el.getAttribute('data-full');
    var inner = el.querySelector('img');
    imgEl.alt = inner ? inner.alt : '';
    countEl.textContent = (at + 1) + ' of ' + items.length;
    var multiple = items.length > 1;
    box.querySelector('.corp-lightbox__nav--prev').hidden = !multiple;
    box.querySelector('.corp-lightbox__nav--next').hidden = !multiple;
    countEl.hidden = !multiple;
  }

  function step(by) { show(at + by); }

  function open(list, i, from) {
    items = list;
    opener = from;
    if (!box) build();
    show(i);
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    box.querySelector('.corp-lightbox__close').focus();
  }

  function close() {
    if (!box) return;
    box.hidden = true;
    imgEl.src = '';
    document.body.style.overflow = '';
    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  document.addEventListener('keydown', function (e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });

  function wire() {
    var galleries = document.querySelectorAll('.article-gallery');
    for (var g = 0; g < galleries.length; g++) {
      (function (gallery) {
        var list = Array.prototype.slice.call(
          gallery.querySelectorAll('[data-gallery-item]'));
        for (var i = 0; i < list.length; i++) {
          (function (el, idx) {
            if (el.dataset.corpWired) return;
            el.dataset.corpWired = '1';
            el.addEventListener('click', function () { open(list, idx, el); });
          })(list[i], i);
        }
      })(galleries[g]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', wire);
})();
